import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: ReactNode;
  onClick?: () => void;
  size?: 'md' | 'lg';
  className?: string;
  variant?: 'primary' | 'inverted' | 'outline';
}
export function CTAButton({
  children,
  onClick,
  size = 'md',
  className = '',
  variant = 'primary'
}: CTAButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center font-bold rounded-lg transition-all duration-300';
  const sizeClasses = size === 'lg' ? 'px-8 py-4 text-lg md:text-xl' : 'px-6 py-3 text-base';
  const variantClasses = variant === 'primary' ? 'bg-gradient-fire text-white hover:shadow-fire' : variant === 'inverted' ? 'bg-white text-bg-primary hover:bg-brand-gold hover:text-bg-primary' : 'border border-brand-gold/40 text-brand-gold hover:bg-brand-gold/10';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`${baseClasses} ${sizeClasses} ${variantClasses} ${className}`} data-id="element-55">
      {children}
    </motion.button>;
}